import React from 'react';
import { SITE } from '../data/mock';

/**
 * VoIPinger logo wrapper.
 * Uses the original VoIPinger logo image, served in higher quality.
 *  - variant="color"  → original logo, untouched (for light backgrounds)
 *  - variant="white"  → original logo with a CSS filter that turns
 *                       the wordmark fully white (for dark backgrounds)
 *
 * The white variant uses `brightness(0) invert(1)` so any change to the
 * source logo (replaced with a real white asset later) keeps working
 * without code changes.
 */
export default function Logo({ variant = 'color', className = 'h-10 w-auto', alt = 'VoIPinger' }) {
  const isWhite = variant === 'white';
  return (
    <img
      src={SITE.logo}
      srcSet={`${SITE.logo} 1x, ${SITE.logo} 2x`}
      alt={alt}
      width="180"
      height="48"
      decoding="async"
      loading="eager"
      className={className}
      style={
        isWhite
          ? { filter: 'brightness(0) invert(1)', imageRendering: 'auto' }
          : { imageRendering: 'auto' }
      }
    />
  );
}
